<template>
  <div>
    <a href="./index.html" class="logo">
      <img src="/media/login/logo.png" alt="logo" />
    </a>
    <h4 class="title">ورود به کاربن</h4>
    <p class="sub-title">رمز عبور خود را وارد کنید</p>
    <div class="alert alert-error" v-if="errors.length">
      <div class="alert-content">
        <div class="alert-body">
          <p v-for="(item, i) in errors" :key="i">{{ item }}</p>
        </div>
      </div>
    </div>
    <div class="alert alert-error" v-if="pageError.length">
      <div class="alert-content">
        <div class="alert-body">
          <p v-for="(item, i) in pageError" :key="i">{{ item }}</p>
        </div>
      </div>
    </div>
    <form @submit.stop.prevent="checkPassword">
      <div class="form-row">
        <div class="form-group">
          <img src="/media/login/lock.svg" alt="lock" class="lock-icon" />
          <input
            type="password"
            name="phone_number"
            class="form-control ltr"
            v-model="password"
          />
        </div>
      </div>
      <div class="links d-flex align-items-center justify-content-between">
        <!-- <router-link @click.native.prevent="requestCode('confirmation')" class="link-form">ورود با کد یکبارمصرف</router-link> -->
        <a href="#" @click.prevent="requestCode('confirmation')" class="link-form">ورود با کد یکبارمصرف</a>
        <a href="./forget-password.html" class="link-form"
          >رمزم را فراموش کردم</a
        >
      </div>
      <button type="submit" class="btn btn-primary" ref="login-button">
        <span class="loading-wrapper" ref="login-span">
          <span class="button__text">ورود به سایت</span>
        </span>
      </button>
    </form>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "CheckPassword",
  data() {
    return {
      password: "",
      pageError: []
    };
  },
  props: {
    message: Object,
  },
  methods: {
    checkPassword() {
      this.$emit(
        "submited",
        this.password,
        this.$refs["login-span"],
        this.$refs["login-button"]
      );
    },
    requestCode(routeName) {
      let page = this;

      this.$store.dispatch('auth/requestOtp', this.phoneNumber)
        .then(({data}) => {
          if(data.result && data.status) {
            this.$router.push({ name: routeName });
          } else {
            this.errors = [data.message];
          }
        })
        .catch(function(error) {
          console.log('error in check password request otp: ', error);
          page.pageError = [error];
        });
    }
  },
  computed: {
    ...mapState({
      errors: (state) => state.auth.errors,
      phoneNumber: (state) => state.auth.phoneNumber,
    }),
  },
};
</script>